import { render, staticRenderFns } from "./VoiceCommands.vue?vue&type=template&id=c0d7cf60&scoped=true"
import script from "./VoiceCommands.vue?vue&type=script&lang=js"
export * from "./VoiceCommands.vue?vue&type=script&lang=js"
import style0 from "./VoiceCommands.vue?vue&type=style&index=0&id=c0d7cf60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0d7cf60",
  null
  
)

export default component.exports